import * as React from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Fab,
  CircularProgress,
  IconButton,
  Tooltip,
} from '@mui/material'
import { Check, Save, DeleteOutline } from '@mui/icons-material'
import { green, red } from '@mui/material/colors'
import { updateFamilyTableById } from '../../../services'
import { setIsStored } from '../../../redux/slices/Alerts'

const FamilyActions = ({ params, rowId, setRowId, onRequestDelete }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const normalizeValidationStatus = value => {
    if (!value) return null
    const normalized = String(value).trim().toLowerCase()
    if (normalized === 'verificado') return 'verificado'
    if (normalized === 'pendiente') return 'pendiente'
    return normalized
  }

  const isSuccessfulResponse = result => {
    if (!result) return false
    const hasExplicitFailure =
      result?.update === false ||
      result?.updated === false ||
      result?.success === false ||
      result?.deleted === false ||
      Boolean(result?.error) ||
      Boolean(result?.errors)
    return !hasExplicitFailure
  }

  const handleSubmit = async () => {
    setLoading(true)
    const { id, nombre, habilitado, estado_validacion } = params.row
    const normalizedStatus = normalizeValidationStatus(estado_validacion)
    const data = { nombre, habilitado: Boolean(habilitado) }
    if (normalizedStatus) data.estado_validacion = normalizedStatus

    const result = await updateFamilyTableById(data, id)
    if (isSuccessfulResponse(result)) {
      setSuccess(true)
      setRowId(null)
      dispatch(setIsStored({ stored: true, message: result?.message || 'Familia actualizada correctamente.' }))
    } else {
      dispatch(setIsStored({ stored: false, message: result?.message || 'No se pudo actualizar la familia.' }))
    }
    setLoading(false)
  }

  React.useEffect(() => {
    if (rowId === params.id && success) setSuccess(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId])

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 0.5, alignItems: 'center' }}>
      {success ? (
        <Fab color="primary" sx={{ width: 40, height: 40, bgcolor: green[500], '&:hover': { bgcolor: green[700] } }}>
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{ width: 40, height: 40 }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}>
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{ color: green[500], position: 'absolute', top: -6, left: -6, zIndex: 1 }}
        />
      )}

      <Tooltip title="Eliminar familia">
        <IconButton
          size="small"
          onClick={() => onRequestDelete(params.row)}
          sx={{ color: red[600], '&:hover': { bgcolor: red[50] } }}>
          <DeleteOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default FamilyActions
